import React, { useState, useEffect } from 'react';
import { Container, Content, BubbleSelectBlock, Title, i18n, tokens, Button } from '@simplybenefits/sb-ui-library';
import { connect } from "react-redux";
import { setCurrentSidebarItem } from '../../actions/user.js';
import Card from '../Card/index.js';
import Details from './Details.js';
import { downloadPDFToBrowser } from '../../services/helpers.js';

/**
 * 
 * @param {*} param0 
 */
const DownloadButton = ({ displayPlanDetails = false, dispatch }) => {
    const styles = {
        downloadBtnContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            marginBottom: 10,
            marginRight: 65
        }
    };

    const componentName = displayPlanDetails ? 'PlanDetails' : 'MyCard';
    const fileName = displayPlanDetails ? 'Plan_Details.pdf' : 'Benefits_Card.pdf';

    return (
        <div style={ styles.downloadBtnContainer }>
            <Button transparent onClick={ () => downloadPDFToBrowser(componentName, fileName, dispatch) }>
                { i18n.t(tokens.buttons["download printable version"])}
            </Button>
        </div>
    );
};

/**
 * 
 * @returns 
 */
const index = ({ dispatch }) => {
    const [ displayPlanDetails, setDisplayPlanDetails ] = useState(false);

    useEffect(() => {
        dispatch(setCurrentSidebarItem('benefits-card'));
    }, []);
    
    return (
        <Container>
            <Content>
                <Title title={i18n.t(tokens.titles["benefits card"])} />
                <BubbleSelectBlock 
                    first={{
                        title: i18n.t(tokens.titles["benefits card"]),
                        selected: !displayPlanDetails
                    }}
                    second={{
                        title: i18n.t(tokens.titles.planDetails),
                        selected: displayPlanDetails
                    }}
                    handleChange={() => setDisplayPlanDetails(!displayPlanDetails)}
                    customStyle={{
                        marginTop: 30,
                        marginBottom: 30
                    }}
                    text={''}
                />
               
                <DownloadButton
                    displayPlanDetails={displayPlanDetails}
                    dispatch={dispatch}
                />

                { 
                    displayPlanDetails ? 
                        (
                            <Details />
                        )
                        : (
                            <Card />
                        )
                }
            </Content>
        </Container>
    );
};

export default connect()(index);